




























































helpers = require('../../helpers.coffee')

view_model =

  components:
    emailServiceDropdown: require('./email_service_dropdown')

  data: ->
    company: new Company(email_service: 'nylas')
    account_setting_selected: { name: 'basic', max_number_of_regular_users: 3 }
    account_setting: new AccountSetting

  methods:
    submit: ->
      @$validator.validateAll().then =>
        @save()

    updateCompany: ->
      @account_setting.name = @account_setting_selected.name
      if( @account_setting.isCustom() )
        @account_setting.max_number_of_regular_users = parseInt(@account_setting.max_number_of_regular_users)
      else
        @account_setting.max_number_of_regular_users = @account_setting_selected.max_number_of_regular_users
      @account_setting.max_number_of_monitoring_managers = parseInt(@account_setting.max_number_of_monitoring_managers)
      @company.account_setting = @account_setting
      @company.active = true

    save: ->
      Loader.on()
      @updateCompany()
      new CompaniesResource().create(@saveSuccess, @handleApiErrors, @company.serialize())

    saveSuccess: (response) ->
      Loader.off()
      alertify.success(this.$t('companies.actions.created'))
      @$router.push('/configuracoes/empresas')

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/companies/new.vue